import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { onClickEvent } from '../../lib/gaAnalytics';
import styles2 from '../Ecs/EcsPortal.module.scss';
import styles from '../../styles/Accordion.module.scss';
import { CreateTicket, handleImpressionsTrack, uploadFiles } from '../../api';
import useAlert from '../../hooks/useAlert';
import {
  checkEngChars,
  CheckingValidComment,
  clickTracker,
  getCommentErrorMsg,
  getPaymentsSubEventType,
  getProjectId,
  getSubEventType,
  hasJdMartVertical,
} from '../../lib/common';
import { useLocalStorage, useSessionStorage } from '../../hooks';
import { useAppState } from '../../contexts/appState';
import { handleLoginPopup } from '../../reducersAndActions/actions/appStateActions';
import { useAuth } from '../../contexts/auth';
import TagsFeedback from '../TagsFeedback/TagsFeedback';

export default function FaqTicketCreate({
  issue, // issue for ticket creation API
  subIssue, // subIssue for ticket creation API
  activeIndex, // if you are using it in accordian current active Index of the accordian
  setShowData, // after ticket creation the original value should show
  vertical, // vertical for ticket creation API
  category, // category for ticket creation API
  ticketCreator, // ticket_creator for ticket creation API
  hideCrossIcon, // if you want to hide the cross icon
  externalHandleSubmit, // instead of internal ticket create function you need to use the parent function
  id,
  setIsHelful,
  faqId,
  ticketType,
  setShowTicketCreate,
  currentPrcType,
  handleContractCheckboxSubmit,
  trackerKey,
  faqObj,
  activeFaq = '',
  displayAlert,
  leadDetails,
}) {
  const [selectedBusiness] = useLocalStorage('selectedBusiness', '');
  const [userDetails] = useSessionStorage('userDetails', '');
  const queryParams = new URLSearchParams(window.location.search);
  const [ticketDescription, setTicketDescription] = useState('');
  const [_result, _setResult] = useState('');
  const [setAlert] = useAlert();
  const selectedBusinessGenio = JSON.parse(localStorage.getItem('selectedBusinessGenio'));
  const profile = JSON.parse(sessionStorage.getItem('profileDetails'));
  const projectId = getProjectId();
  const [isButtonClicked, setIsButtonClicked] = useState(false);
  let enableSubmitButton =
    CheckingValidComment(ticketDescription) && !isButtonClicked && checkEngChars(ticketDescription);
  const [appState, appDispatch] = useAppState();
  const [fileData, setFileData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [descriptionOpen, setDescriptionOpen] = useState(false);
  const [authState] = useAuth();
  useEffect(() => {
    if (activeIndex !== -1) {
      setTicketDescription('');
      _setResult('');
      setIsButtonClicked(false);
    }
  }, [activeIndex]);

  const document = [];
  fileData.forEach((item) => {
    document.push({
      nm: item.name,
      url: item.url,
    });
  });

  const handleCreateTicket = async () => {
    setIsButtonClicked(true);
    if (id === 'faqPage') {
      if (appState?.loginPopup?.nonlogin && !authState?.sidResponse) {
        handleLoginPopup(appDispatch, { ...appState.loginPopup, open: true, click: true });
        return;
      }
    }
    const params = {
      vertical:
        issue === 'COMPLAINT-SALES TEAM'
          ? 'LISTING'
          : hasJdMartVertical()
            ? 'JD MART CORPORATE'
            : issue === 'UBL Related'
              ? 'GBL'
              : vertical,
      category,
      ticket_creator: ticketCreator,
      nm:
        projectId === 'csportal'
          ? selectedBusiness?.compname || ''
          : selectedBusinessGenio?.contractPersonName || selectedBusinessGenio?.companyName || '',
      created_by: projectId === 'csportal' ? userDetails?.mobile || '' : profile?.mobile || '',
      mob: projectId === 'csportal' ? userDetails?.mobile || '' : selectedBusinessGenio?.mobile || '',
      issue_type: issue,
      issue_sub_type: subIssue,
      issue_comment: ticketDescription,
      document: document || [],
      city:
        projectId === 'genio'
          ? selectedBusinessGenio?.city || ''
          : queryParams.get('city') || selectedBusiness?.data_city,
      oid: '',
      orderid: '',
      docid:
        projectId === 'genio'
          ? selectedBusinessGenio?.docId || ''
          : queryParams.get('pid') || selectedBusiness?.docid || '',
      src: projectId === 'genio' ? 'sales-genio' : 'business',
      src_typ:
        projectId === 'genio' ? (selectedBusinessGenio?.concern === 'client' ? 'client' : 'internal') : 'csportal',
      src_nm: projectId === 'csportal' ? userDetails?.fullName || '' : profile?.full_name || '',
      src_mob: projectId === 'csportal' ? userDetails?.mobile || '' : profile?.mobile || '',
      projectId: projectId === 'csportal' ? 1 : '',
      parentId: projectId === 'genio' ? selectedBusinessGenio?.parentId || '' : selectedBusiness?.parentid || '',
      compnm: projectId === 'genio' ? selectedBusinessGenio?.companyName || '' : selectedBusiness?.compname || '',
      source: hideCrossIcon ? `description box_submitbutton_${projectId}` : `description box_thumbsdown_${projectId}`,
      classify: 1,
      bypass_autoclassify:
        issue?.trim().toLowerCase() === 'lead bank - b2b' ||
        issue?.trim().toLowerCase() === 'book appointment' ||
        !ticketDescription
          ? 1
          : 0,
      ...(projectId === 'genio' && {
        agent_mngr_id: profile?.reporteeCode,
        agent_id: profile?.empCode,
      }),
    };
    if (trackerKey === 'ublconcern') {
      params.team = 'cs-omni';
    }
    const res = await CreateTicket(params);
    if (res?.errorCode === 0) {
      _setResult(res.result.msg);
      if (['contractCheckboxSubmit', 'editListingPage', 'faqPage'].includes(id)) {
        handleContractCheckboxSubmit(res?.result?.msg);
        return;
      }

      if (
        id !== 'leads' &&
        id !== 'payments' &&
        id !== 'contractCheckboxSubmit' &&
        id !== 'ecs' &&
        id !== 'editBusiness'
      ) {
        if (setShowData) {
          setShowData(true);
          setAlert({
            message: res?.result?.msg,
            status: true,
          });
        }
      }
    } else {
      setAlert({
        message: res?.message || '',
        status: false,
      });
    }

    setIsButtonClicked(false);
    if (projectId === 'csportal') {
      const liVal = 'click';
      const liTrd = `click_${faqObj?.faqKey}_submit`;
      const faqTypeVal = '';
      const othersData = [];
      const llTrd = `click_${faqObj?.faqKey}`;
      const llTrdInside = `faq_${faqObj?.faqKey}`;
      await handleImpressionsTrack(liVal, liTrd, faqTypeVal, othersData, llTrd, authState, llTrdInside);
    }
    if (id === 'payments') {
      await clickTracker(
        `FAQ_${getPaymentsSubEventType?.[faqId]}_${ticketType === 'faqTicketCreate' ? 'submit' : 'ticket'}`,
        `payments_FAQ_${ticketType === 'faqTicketCreate' ? getPaymentsSubEventType?.[faqId] : 'feedback_ticket'}`,
      );
    }
    if (id === 'paymentChequeStatus' && faqId === 8) {
      await clickTracker('FAQ_stopcheque_submit', 'payments_FAQ_stopcheque');
    }

    if (id === 'leads') {
      await clickTracker(`${getSubEventType[faqId]}_ticket`, 'leads_FAQ_ticket');
    }
    if (id === 'editBusiness') {
      await clickTracker(
        `FAQ_${trackerKey}_${hideCrossIcon ? 'submit' : 'ticket'}`,
        `editdata_FAQ_${hideCrossIcon ? trackerKey : 'feedback_ticket'}`,
      );
    }
    if (id === 'ecs' && currentPrcType) {
      if (projectId === 'csportal') {
        await clickTracker(`feedback_${currentPrcType}_ticket`, `ecs_FAQ_feedback_ticket`);
      } else {
        await clickTracker(
          `FAQ_${
            currentPrcType === 'bounce'
              ? 'paybounced'
              : currentPrcType === 'ecs-clearance'
                ? 'clearanceinfo'
                : currentPrcType
          }_ticketG`,
          `ecs_FAQ_feedback_ticket`,
        );
      }
    }
    setFileData([]);
  };
  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    const sizeInKB = (file.size / 1024).toFixed(2);
    onClickEvent(`CS-Create Ticket Page`, 'Attachment Uploaded', `Attachment Uploaded ${(file && file?.type) || ''}`);
    if (file && file.type.startsWith('image/')) {
      const files = event.target.files ? [...event.target.files] : [];
      const tempFileData = [...fileData];
      try {
        setLoading(true);
        const response = await uploadFiles(files, true);
        if (response.error_code === 0) {
          if (response.image_urls && response.image_urls.length > 0) {
            tempFileData.push({ name: files[0].name, url: response.image_urls[0], size: `${sizeInKB} Kb` });
            setFileData(tempFileData);
          }
        } else {
          setAlert({
            message: 'Invalid file format',
            status: false,
          });
        }
        setLoading(false);
      } catch (err) {
        console.log('Error: ', err);
      }
    } else {
      setAlert({
        message: 'Accepts only image file',
        status: false,
      });
    }
  };

  const deleteImage = (index) => {
    const tempFileData = [...fileData];
    tempFileData.splice(index, 1);
    setFileData(tempFileData);
  };
  if (trackerKey === 'ublconcern') {
    enableSubmitButton =
      CheckingValidComment(ticketDescription) &&
      !isButtonClicked &&
      checkEngChars(ticketDescription) &&
      fileData &&
      fileData.length > 0;
  }
  const tagsFeedbackParams = {
    vertical,
    category,
    ticketCreator,
    issue,
    subIssue,
    selectedBusiness,
    userDetails,
    selectedBusinessGenio,
    profile,
    projectId,
  };
  const shouldShowDescription = activeFaq === 'noLeads' && displayAlert ? descriptionOpen : true;

  return (
    <div
      style={
        window.location.pathname.includes('LeadBank')
          ? { background: '#f9f9f9', borderRadius: '5px', padding: '10px' }
          : {}
      }
    >
      {projectId === 'csportal' && appState?.tagsFeedbackPage?.status ? (
        <TagsFeedback
          tagsFeedbackParams={tagsFeedbackParams}
          setAlert={setAlert}
          faqQuestion={appState?.tagsFeedbackPage?.question}
          id={id}
          faqObj={faqObj}
          activeFaq={activeFaq}
          displayAlert={displayAlert}
          leadDetails={leadDetails}
        />
      ) : (
        <>
          {!hideCrossIcon && !_result && (
            <div
              aria-label="Close Modal"
              tabIndex={0}
              role="button"
              onKeyDown={() => {}}
              style={{ float: 'right', cursor: 'pointer', marginBottom: '5px', fontSize: '13px' }}
              onClick={() => {
                const includedArr = ['PAY BOUNCED AMOUNT', 'ECS RELATED INFORMATION'];
                if (includedArr.includes(subIssue)) {
                  if (id === 'ecs') setIsHelful(true);
                } else if (id === 'paymentChequeStatus') {
                  setShowTicketCreate(false);
                } else if (id === 'ecs') {
                  setIsHelful(false);
                }

                setShowData(true);
              }}
            >
              X
            </div>
          )}
          <div className="csexpndwp_content">
            {displayAlert && activeFaq === 'noLeads' && (
              <div className={`${styles.Frame_144858}`}>
                <div className={`${styles.Frame_2125770705}`}>
                  <div className={`${styles.Contract_Details}`}>
                    You've recieved {leadDetails?.leadscount} leads this week!
                  </div>
                </div>
                <div className={`${styles.Frame_2125770705}`}>
                  <div className={`${styles.Frame_2125770708}`}>
                    <div className={`${styles.notif}`}>Stay Notified</div>
                  </div>
                  <div className={`${styles.lead_notif}`}>You will get lead notifications on</div>
                  <div className={`${styles.Frame_2125770712}`}>
                    <span className={`${styles.num}`}>{leadDetails?.mobileFeeback}</span>
                  </div>
                  <div className={`${styles.Frame_144847}`} onClick={() => setDescriptionOpen((prev) => !prev)}>
                    <span className={`${styles.txt}`}>Still Facing an Issue?</span>
                  </div>
                </div>
              </div>
            )}
            {!_result ? (
              <div
                style={
                  window.location.pathname.includes('LeadBank')
                    ? { background: '#f9f9f9', borderRadius: '5px', padding: '10px' }
                    : {}
                }
              >
                {shouldShowDescription && (
                  <>
                    <div style={{ marginBottom: '10px' }}>
                      <span style={{ fontSize: '15px' }}>Description</span>
                      <span style={{ color: 'red', marginLeft: '4px' }}>*</span>
                    </div>
                    <textarea
                      className={`${styles2.Accordion__TextArea}`}
                      value={ticketDescription}
                      placeholder={
                        id === 'paymentChequeStatus' && faqId === 8
                          ? 'Please mention your cheque number and comments if any'
                          : 'Please describe your issue here, our team will get back to you within 24-48 hours'
                      }
                      onChange={(e) => {
                        setTicketDescription(e.target.value);
                      }}
                    />
                  </>
                )}
                {trackerKey === 'ublconcern' && (
                  <div className="group phy_mandate_list uploadphoto mt-20 mb-15 mb-0">
                    <div style={{ marginBottom: '10px' }}>
                      <span style={{ fontSize: '15px' }}>Uploaded Attachments</span>
                      <span style={{ color: 'red', marginLeft: '4px' }}>*</span>
                    </div>
                    {fileData && fileData.length > 0
                      ? fileData.map((each, idx) => (
                          <span key={idx} className="uploaded_img mr-10 mb-10">
                            <img key={idx} alt={each.name} src={each.url} />
                            <span className="uploaded_img_text font11 colorFFF">
                              <div
                                onClick={() => deleteImage(idx)}
                                onKeyDown={() => {}}
                                className="ml-5"
                                key={idx}
                                role="button"
                                tabIndex="0"
                                aria-label="Delete image"
                                style={{ display: 'inline-block' }}
                              >
                                <img
                                  alt="delete_img"
                                  src="https://images.jdmagicbox.com/standard/cs_module/baf79d55c4951b13b60ebbb1c5f9e773.jpg"
                                />
                              </div>
                            </span>
                            <span className="uploaded_overlay" />
                          </span>
                        ))
                      : loading && (
                          <span className="uploaded_img">
                            <div
                              style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                height: '100%',
                              }}
                            >
                              <div className="bt-spinner" style={{ height: '25px', width: '25px' }} />
                            </div>
                          </span>
                        )}
                    {fileData.length < 5 && (
                      <span className="uploaded_img">
                        <span className="upload_type_wpr color393 font11">
                          <input
                            type="file"
                            accept="image/*"
                            onChange={handleFileUpload}
                            onClick={(e) => {
                              e.target.value = null;
                            }}
                            name=""
                          />
                          <img
                            alt="addPhoto"
                            src="https://akam.cdn.jdmagicbox.com/images/icons/genio/gno_addphoto.svg"
                          />
                        </span>
                      </span>
                    )}
                  </div>
                )}
                {shouldShowDescription && (
                  <button
                    type="button"
                    className={`${styles.Accordion__Contant__Button} bluefill_animate font14 fw600 colorFFF mt-10`}
                    style={{
                      backgroundColor: `${enableSubmitButton ? '#0076d7' : '#CCCCCC'}`,
                      border: `1px solid ${!enableSubmitButton ? '#E0E0E0' : '#CCCCCC'}`,
                      transitionProperty: 'background-color, background-image, border-color, box-shadow',
                      transition: 'all 0.8s',
                      color: `#FFFFFF`,
                    }}
                    disabled={!enableSubmitButton}
                    onClick={async () => {
                      if (externalHandleSubmit) externalHandleSubmit();
                      else handleCreateTicket();
                    }}
                  >
                    Submit
                  </button>
                )}
                {ticketDescription && !CheckingValidComment(ticketDescription) && ticketDescription.length > 3 && (
                  <span className="colorEC4 font12 fw500">{getCommentErrorMsg(ticketDescription)}</span>
                )}
              </div>
            ) : (
              <div
                className="font12 fw400 color777"
                style={{ height: 'fit-content', userSelect: 'text', cursor: 'pointer' }}
              >
                {_result}
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
}
FaqTicketCreate.propTypes = {
  issue: PropTypes.string,
  subIssue: PropTypes.string,
  setShowData: PropTypes.func,
  activeIndex: PropTypes.number,
  category: PropTypes.string,
  vertical: PropTypes.string,
  ticketCreator: PropTypes.string,
  hideCrossIcon: PropTypes.bool,
  externalHandleSubmit: PropTypes.func,
  setIsHelful: PropTypes.func,
  id: PropTypes.string,
  faqId: PropTypes.number,
  ticketType: PropTypes.string,
  setShowTicketCreate: PropTypes.func,
  currentPrcType: PropTypes.string,
  handleContractCheckboxSubmit: PropTypes.func,
  trackerKey: PropTypes.string,
  faqObj: PropTypes.object,
  activeFaq: PropTypes.string,
  displayAlert: PropTypes.bool,
  leadDetails: PropTypes.object,
};
